module.exports = __webpack_public_path__ + "media/images/FortWaynes-black-950504f86d3c53dd81d032bad0f82867.png";